import { AssetTypeService } from './asset-type.service';
import { Injectable } from '@angular/core';
import { AlertController, NavController, LoadingController, ModalController } from '@ionic/angular';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { NavigationExtras } from '@angular/router';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import { ApiProjectService } from '../api-services/project.api.service';
import { Project } from '../models/Project';
import { ApiSceneService } from '../api-services/scene.api.service';
// import { ApiSceneBackgroundService } from '../api-services/scene-background.api.service';
// import { SceneBackground } from '../models/SceneBackground';
import { Scene } from '../models/Scene';
import { AddProjectModalPage } from '../modals/add-project-modal/add-project-modal.page';
import { ApiSceneAssetRelationService } from '../api-services/scene-asset-relation.api.service';
import { ApiAssetService } from '../api-services/asset.api.service';
import { AssetInScene } from '../models/AssetInScene';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { Model3DSceneAssetRelation } from '../models/scene-asset-relations/model3DSceneAssetRelation';
import { CopyService } from './copy.service';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { MessagesService } from './messages.service';
import { ApiExportService } from '../api-services/export.api.service';
import { DeepCopyService } from './deep-copy.service';
import { XapiProjectLaunch } from '../models/XapiProjectLaunch';
import { ExportParameters } from '../models/export/ExportParameters';
import { CryptoService } from './crypto.service';
import { CustomerUsageService } from './customer-usage.service';
import { StorageService } from './storageService.service';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  public project: Project;
  public scenes: Scene[] = [];
  public projects: Project[] = [];
  public projectsCopy: Project[] = [];
  public copyThisProjectId: number;
  public backgroundDefault: string = 'assets/DefaultProjectThumbnail.png';
  public cardBackgroundDefault: string = 'assets/project-card-background.png';
  private _isModalOpen: boolean = false;
  public projectLoading: boolean = false;

  public projectFilter = {
    name: '',
  }

  // sceneBackgrounds: SceneBackground[] = [];
  constructor(
    public alertController: AlertController,
    public modalController: ModalController,
    public alertService: AlertService,
    public navController: NavController,
    private storage: Storage,
    private httpClient: HttpClient,
    public apiProjectService: ApiProjectService,
    public apiExportService: ApiExportService,
    public loadingController: LoadingController,
    public sceneAPIService: ApiSceneService,
    public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
    // public sceneBackgroundAPIService: ApiSceneBackgroundService,
    public assetAPIService: ApiAssetService,
    public assetTypeService: AssetTypeService,
    public copyService: CopyService,
    public messagesService: MessagesService,
    public deepCopyService: DeepCopyService,
    public cryptoService: CryptoService,
    public customerUsageService: CustomerUsageService,
    public storageService: StorageService,
    public customerService: CustomerService
  ) {
    this.getProjects();
  }

  randomProjectId(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  loadProjects() {
    this.loadProjectsFromCloud();
  }

  async loadProjectsFromCloud() {

  }

  async saveProjectsToCloud() {
    var email = this.cryptoService.decryptData(this.storageService.getItem("login_email"));

    await this.messagesService.presentLoadingWindow('Saving projects to cloud.');

    this.uploadProjectsData(JSON.stringify(this.projects), email).subscribe(res => {
      this.messagesService.loadingWindow.dismiss().then(() => {
      });
    });

    //this.projects.forEach(project => {
    // this.uploadProjectData(JSON.stringify(project.projectScenes), project.externalId).subscribe((res) => {
    //   //
    // });
    //});
  }

  async exportProject(project: Project, exportParameters: ExportParameters): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.apiExportService.exportProjectRequest(project.projectId, exportParameters).subscribe((response) => {
        resolve(response);
      },
        error => {
          let url: string = error.error.text;
          resolve(url);
        });
    });
  }

  async exportRationalReport(exportRationalReport) {
    await this.messagesService.presentLoadingWindow('Exporting report, please wait.');
    this.exportRationalReportData(JSON.stringify(exportRationalReport)).subscribe(res => {
      this.messagesService.loadingWindow.dismiss();
    },
      error => {
        window.location.href = API_SETTINGS.API_URL + "file/" + error.error.text;
      });
  }

  async exportUnpackagedProject(project: Project, exportParameters: ExportParameters): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.apiExportService.exportUnpackagedProjectRequest(project.projectId, exportParameters).subscribe((response) => {
        //resolve(response);
      },
        error => {
          resolve(error.error.text);
        });
    });
  }

  async sendInvitationsToLearners(project: Project, exportParameters: ExportParameters) {
    if (exportParameters.learners.length > 200) {
      exportParameters.learners.splice(200, exportParameters.learners.length - 200);
    }

    return new Promise<string>((resolve, reject) => {
      this.apiExportService.sendInvitationsToLearnersRequest(project.projectId, exportParameters).subscribe((response) => {
        resolve(response);
      },
        error => {
          resolve(error.error.text);
        });
    });
  }

  async previewProject(project) {
    this.navController.navigateForward("/preview").then(() => {

    });
  }

  uploadProjectsData(projectsJson, email): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/save/" + email;
    const formData: FormData = new FormData();
    formData.append("projectsJson", projectsJson);
    return this.httpClient.post<any>(url, formData);
  }

  downloadProjectsData(email): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/load/" + email;
    return this.httpClient.get<any>(url);
  }

  uploadProjectData(projectJson, id): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/saveProject/" + id;
    const formData: FormData = new FormData();
    formData.append("projectsJson", projectJson);
    return this.httpClient.post<any>(url, formData);
  }

  downloadProjectData(id): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/loadProject/" + id;
    return this.httpClient.get<any>(url);
  }

  previewProjectData(projectJson): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/preview";
    const formData: FormData = new FormData();
    formData.append("projectJson", projectJson);
    return this.httpClient.post<any>(url, formData);
  }

  exportRationalReportData(exportRationalReportJson): Observable<any> {
    var url = API_SETTINGS.API_URL + "export/rationale";
    const formData: FormData = new FormData();
    formData.append("exportRationalReportJson", exportRationalReportJson);
    return this.httpClient.post<any>(url, formData);
  }

  async presentUpsertProject(project, toEditor) {
    var isEditing: boolean;
    project == null ? isEditing = false : isEditing = true;

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const addOrEditProjectModal = await this.modalController.create({
      id: 'add-project-modal',
      component: AddProjectModalPage,
      componentProps: {
        "toEditor": toEditor,
        "isEditing": isEditing,
        "project": project == null ? new Project() : this.deepCopyService.deepCopy(project),
      }
    });

    addOrEditProjectModal.onDidDismiss().then(async result => {
      if (result.data) {
        var projectForDb: Project = this.populateProject(result.data, project);
        if (project == null) {
          await this.messagesService.presentLoadingWindow("Creating project: " + result.data.name);
          this.apiProjectService.addProject(projectForDb).subscribe(res => {
            if (res) {
              this.getProjects();

              if (toEditor) {
                this.getProject(res.projectId).subscribe(
                  result => {
                    this.launchProject(result);
                  },
                  error => {
                    
                  }
                );
              }
            }
            this.messagesService.loadingWindow.dismiss();
            this.messagesService.presentToast('New project added successfully!', 'success', 'Projects');
          });
        } else {
          await this.messagesService.presentLoadingWindow("Updating project: " + result.data.name);
          this.apiProjectService.updateProject(project.projectId, projectForDb).subscribe(res => {
            this.getProjects().then(x => {
              this.messagesService.loadingWindow.dismiss();
              this.messagesService.presentToast('Project saved successfully!\r\n' + this.messagesService.getDateString(res.timeStamp, this.customerService.customer.dateFormat, this.customerService.customer.timeZone), 'success', 'Projects');
            });

          })
        }
      } else if (isEditing) {
        this.resetProject(project.projectId);
      }
      this._isModalOpen = false;
    });

    return await addOrEditProjectModal.present();
  }

  async copyProject(project: Project) {
    var projectName = project.name;
    await this.messagesService.presentLoadingWindow("Copying project: " + projectName);
    project.name = this.copyService.copyName(projectName, this.projects);
    this.copyService.copyProject(project).then(newProject => {
      this.getProjects();
      this.messagesService.loadingWindow.dismiss();
      this.messagesService.presentToast("Project duplicated successfully!", "success", 'Projects');
    });
    project.name = projectName;
  }

  resetProject(projectId: number) {
    this.apiProjectService.getProject(projectId).subscribe(result => {
      var project: Project = this.projects.filter(p => p.projectId == projectId)[0];
      project.name = result.name;
      project.description = result.description;
      project.category = result.category;
    })
  }

  populateProject(data: Project, project: Project): Project {
    var projectForDb: Project = new Project();
    projectForDb.projectId = project != null ? project.projectId : 0,
      projectForDb.name = data.name;
    projectForDb.description = data.description;
    projectForDb.active = true;
    projectForDb.companyName = data.companyName;
    projectForDb.customerId = +this.cryptoService.decryptData(this.storageService.getItem('customerId'));
    projectForDb.category = data.category;
    projectForDb.pincode = Math.floor(1000 + Math.random() * 9000).toString();
    projectForDb.number = Math.floor(1000 + Math.random() * 9000).toString();
    projectForDb.favourite = data.favourite;
    return projectForDb;
  }

  setMaxLengths() {
    document.getElementById('maxLength30').setAttribute('maxlength', '30');
    document.getElementById('maxLength50').setAttribute('maxlength', '50');
    document.getElementById('maxLength200').setAttribute('maxlength', '200');
  }


  getProject(id) {
    return this.apiProjectService.getProject(id);
  }

  getProjects() {
    return new Promise<void>((resolve) => {
      this.apiProjectService.getProjectsWithCustomerId(+this.cryptoService.decryptData(this.storageService.getItem('customerId'))).subscribe(async projects => {
        var favouriteProjects = projects.filter(x => x.favourite);
        var nonFavouriteProjects = projects.filter(x => !x.favourite);
        favouriteProjects.sort((a, b) => a.name.localeCompare(b.name));
        nonFavouriteProjects.sort((a, b) => a.name.localeCompare(b.name));
        favouriteProjects.push(...nonFavouriteProjects);

        await this.getProjectsFirstSceneBackground(favouriteProjects);

        this.projects = favouriteProjects;
        this.projectsCopy = favouriteProjects;
        //this.getProjectsFirstSceneBackground();
        this.setProjectsUsage();
        resolve();
      });
    });
  }

  reinitProjects() {
    this.projects = this.projectsCopy;
    this.setProjectsUsage();
  }

  setProjectsUsage() {
    var projectIds = this.projects.map(x => x.projectId);
    this.apiProjectService.getProjectsLaunchUsage(projectIds).subscribe(projectLaunchValues => {
      for (var projectLaunchValue of projectLaunchValues) {
        var project = this.projects.filter(x => x.projectId == projectLaunchValue.projectId)[0];
        project.usageValue = projectLaunchValue.launchCount * project.projectSize;
      }
    });
  }

  setProjectUsage(projectId: number) {
    return new Promise<void>((resolve) => {
      var projectIds: number[] = [];
      projectIds.push(projectId);

      this.apiProjectService.getProjectsLaunchUsage(projectIds).subscribe(projectLaunchValues => {
        for (var projectLaunchValue of projectLaunchValues) {
          var project = this.projects.filter(x => x.projectId == projectLaunchValue.projectId)[0];
          project.usageValue = projectLaunchValue.launchCount * project.projectSize;
        }
        resolve();
      });
    });
  }

  getProjectStreamingUsage() {
    var projectIds = this.projects.map(x => x.projectId);
    return new Promise<void>((resolve) => {
      this.apiProjectService.getProjectsLaunchUsage(projectIds).subscribe(projectLaunchValues => {
        var values = projectLaunchValues.length;
        var counter = 0;
        for (var projectLaunchValue of projectLaunchValues) {
          var project = this.projects.filter(x => x.projectId == projectLaunchValue.projectId)[0];
          project.launchCount = projectLaunchValue.launchCount;
          project.usageValue = projectLaunchValue.launchCount * project.projectSize;
          counter++;
        }
        if (counter == values) {
          resolve();
        }
      });
    });
  }

  setProjectList() {
    this.apiProjectService.getProjectsWithCustomerId(+this.cryptoService.decryptData(this.storageService.getItem('customerId'))).subscribe(projects => {

    });
  }

  async launchProject(project) {
    this.projectLoading = true;
    await this.messagesService.presentLoadingWindow('Loading project: ' + project.name, 'loading-project');
    document.querySelector('ion-backdrop').style.cssText = "background-color: white; opacity: 1;";
    this.project = project;
    await this.apiProjectService.getProject(project.projectId).subscribe(x => {
      project.timeStamp = x.timeStamp;
      project.projectSize = x.projectSize;
      project.usageValue = x.usageValue;
      this.storageService.setItem('project', this.cryptoService.encryptData(JSON.stringify(project)));
      this.navController.navigateForward("/author").then(res => { });
    });
    //this.getProjectsFirstSceneBackground();

  }

  async deleteProject(project: any) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "are you sure you want to delete the project '" + project.name + "'?",
      buttons: [
        {
          text: 'Cancel',
        }, {
          text: 'Delete',
          handler: () => {
            this.messagesService.presentLoadingWindow("Deleting Project...");
            this.apiProjectService.deleteProject(project.projectId).subscribe(res => {
              this.messagesService.loadingWindow.dismiss();
              this.messagesService.presentToast('Project deleted successfully!', 'success', 'Projects');
              this.getProjects();
            });
          }
        }
      ]
    });
    await alert.present();
  }

  getProjectsFirstSceneBackground(projects: Project[]): Promise<void> {
    return new Promise<void>(async resolve => {
      this.scenes = [];
      for(let i:number = 0; i < projects.length; i++){
        let project = projects[i];
        if(project.defaultSceneId > 0){
          let scene = await this.sceneAPIService.getScene(project.defaultSceneId).toPromise();
          this.scenes.push(scene);
        }
      }
      resolve();
    });
  }

  getSceneBackgroundSrcWithProjectId(projectId: number): string {
    if (this.scenes.length > 0) {
      if (this.scenes.filter(s => s.projectId == projectId)[0]) {
        var scene = this.scenes.filter(s => s.projectId == projectId)[0];
        return this.scenes.filter(sb => sb.sceneId == scene.sceneId)[0].sceneBackgroundSrc;
      }
    }
    return null;
  }

  getProjectBackgroundType(projectId: number): string {
    if (this.scenes.length > 0) {
      if (this.scenes.filter(s => s.projectId == projectId)[0]) {
        return this.scenes.filter(s => s.projectId == projectId)[0].sceneBackgroundFileType;
        // if (this.sceneBackgrounds.filter(sb => sb.sceneId == scene.sceneId)[0]){
        //   return this.sceneBackgrounds.filter(sb => sb.sceneId == scene.sceneId)[0].fileType;
        // }
      }
    }
    return "";
  }

  favouriteProject(project: Project) {
    let favourite = project.favourite ? true : false
    this.apiProjectService.updateProject(project.projectId, project).subscribe(res => {
      this.getProjects();
      if (favourite) {
        this.messagesService.presentToast('Successfully added to your favorite projects.', 'info', 'Projects');
      }
      else {
        this.messagesService.presentToast('Successfully removed from your favorite projects.', 'info', 'Projects');
      }
    })
  }

  updateDefaultSceneId(project: Project) {
    this.apiProjectService.updateProject(project.projectId, project).subscribe(res => {
      this.getProjects();
      if (project.defaultSceneId > 0) {
        this.messagesService.presentToast('Successfully saved as project icon.', 'success', 'Projects');
      }
      else {
        this.messagesService.presentToast('Successfully removed from project icon', 'success', 'Projects');
      }
    })
  }

  getProjectScenes(projectId: number) {
    return this.sceneAPIService.getScenesWithProjectId(projectId).toPromise();
  }

}
